import { CommonModule } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { readAppVersion } from '@core/version/app-version';
import { ModalShellComponent, ModalShellConfig } from '@shared/components/modal-shell/modal-shell.component';

@Component({
  selector: 'app-about-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule, ModalShellComponent],
  templateUrl: './about-dialog.component.html',
  styleUrl: './about-dialog.component.scss',
})
export class AboutDialogComponent implements OnInit {
  readonly modalConfig: ModalShellConfig = { title: 'Acerca de INA Comunidades', size: 'md', layout: 'summary' };
  readonly appVersion = signal('No disponible');

  constructor(private readonly dialogRef: MatDialogRef<AboutDialogComponent>) {}

  ngOnInit(): void {
    void this.loadAppVersion();
  }

  close(): void {
    this.dialogRef.close();
  }

  private async loadAppVersion(): Promise<void> {
    const version = await readAppVersion('No disponible');

    this.appVersion.set(version || 'No disponible');
  }
}
